<template>
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="28" height="28" rx="14" fill="#ECEFF1" />
    <g opacity="0.4" clip-path="url(#clip0_2271_54407)">
      <path
        d="M14.0003 22.3337C9.39783 22.3337 5.66699 18.6028 5.66699 14.0003C5.66699 9.39783 9.39783 5.66699 14.0003 5.66699C18.6028 5.66699 22.3337 9.39783 22.3337 14.0003C22.3337 18.6028 18.6028 22.3337 14.0003 22.3337ZM14.0003 20.667C15.7684 20.667 17.4641 19.9646 18.7144 18.7144C19.9646 17.4641 20.667 15.7684 20.667 14.0003C20.667 12.2322 19.9646 10.5365 18.7144 9.28628C17.4641 8.03604 15.7684 7.33366 14.0003 7.33366C12.2322 7.33366 10.5365 8.03604 9.28628 9.28628C8.03604 10.5365 7.33366 12.2322 7.33366 14.0003C7.33366 15.7684 8.03604 17.4641 9.28628 18.7144C10.5365 19.9646 12.2322 20.667 14.0003 20.667ZM13.167 17.3337C13.167 16.8734 13.5401 16.5003 14.0003 16.5003C14.4606 16.5003 14.8337 16.8734 14.8337 17.3337C14.8337 17.7939 14.4606 18.167 14.0003 18.167C13.5401 18.167 13.167 17.7939 13.167 17.3337ZM13.167 10.667C13.167 10.2068 13.5401 9.83366 14.0003 9.83366C14.4606 9.83366 14.8337 10.2068 14.8337 10.667V14.0003C14.8337 14.4606 14.4606 14.8337 14.0003 14.8337C13.5401 14.8337 13.167 14.4606 13.167 14.0003V10.667Z"
        fill="#263238" />
    </g>
    <defs>
      <clipPath id="clip0_2271_54407">
        <rect width="20" height="20" fill="white" transform="translate(4 4)" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  props: ["color"]
}
</script>